import { render, staticRenderFns } from "./RealNameRegistration.vue?vue&type=template&id=463580dd&scoped=true"
import script from "./RealNameRegistration.vue?vue&type=script&lang=js"
export * from "./RealNameRegistration.vue?vue&type=script&lang=js"
import style0 from "./RealNameRegistration.vue?vue&type=style&index=0&id=463580dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463580dd",
  null
  
)

export default component.exports